export class Meta {
  static STRUCTURE = 'structure';

  static TAXONOMY = 'taxonomy';
}

export class TooltipEvents {
  static ON_HOVER_EVENT = 'tooltipOnHoverHide';

  static ON_CLICK_EVENT = 'tooltipOnClickHide';

  static hideOnHoverTooltips = () => window.dispatchEvent(new CustomEvent(TooltipEvents.ON_HOVER_EVENT));

  static hideOnClickTooltips = () => window.dispatchEvent(new CustomEvent(TooltipEvents.ON_CLICK_EVENT));
}

export const types = {
  substance: 'DAT.MRN',
  target: 'TARGET.HDR_KEY',
  bioassay: 'DAT.ANAME',
  targetSpecies: 'DAT.TSPECIE',
  biologicalSpecies: 'DAT.BSPECIE',
  effect: 'DAT.EFFECT',
  parameter: 'DAT.VTYPE',
  cellLine: 'DAT.BCELL',
};

export const titles = {
  [types.target]: 'Target details',
  [types.bioassay]: 'Bioassay details',
  [types.targetSpecies]: 'Target species details',
  [types.biologicalSpecies]: 'Biological species details',
  [types.effect]: 'Effect details',
  [types.parameter]: 'Parameter details',
  [types.cellLine]: 'Cell line details',
};
